module.exports = __webpack_public_path__ + "static/missy-61408dfb8edf6b158e17a0d63e3a7beb.png";